import {persianCopy} from './persianTranslations.js';
const localizedCopy = {
  "tr": [
    "Hazır sohbet ve kitap metinlerinden soru veya konu seçin. Yeni metinler yayımlandıkça liste güncellenir.",
    "Bu kapsamda erişiminiz olan hazır bir metin henüz yok.",
    "Hazır metinlerden soru ve konu önerisidir; doğrulanmış AI cevabı değildir. Kitap konularında eşleşen PDF sayfaları belirtilir."
  ],
  "en": [
    "Choose a question or topic from prepared talk and book texts. The list updates as new texts are published.",
    "No prepared text is available to you in this scope yet.",
    "These are question and topic suggestions from prepared texts, not verified AI answers. Book topics list matching PDF pages."
  ],
  "de": [
    "Wählen Sie eine Frage oder ein Thema aus vorbereiteten Gesprächs- und Buchtexten. Neue veröffentlichte Texte erweitern die Liste.",
    "In diesem Bereich steht Ihnen noch kein vorbereiteter Text zur Verfügung.",
    "Frage- und Themenvorschläge aus vorbereiteten Texten, keine geprüften KI-Antworten. Buchthemen nennen passende PDF-Seiten."
  ],
  "fr": [
    "Choisissez une question ou un sujet dans les textes disponibles. La liste évolue avec les nouveaux textes publiés.",
    "Aucun texte disponible dans ce périmètre pour votre compte.",
    "Suggestions tirées des textes préparés, pas des réponses IA vérifiées. Les sujets de livres indiquent les pages PDF correspondantes."
  ],
  "es": [
    "Elija una pregunta o tema de los textos preparados. La lista se amplía al publicar nuevos textos.",
    "Aún no hay textos preparados accesibles en este ámbito.",
    "Sugerencias de textos preparados, no respuestas de IA verificadas. Los temas de libros indican las páginas PDF coincidentes."
  ],
  "ar": [
    "اختر سؤالاً أو موضوعاً من نصوص الأحاديث والكتب الجاهزة. تتحدث القائمة عند نشر نصوص جديدة.",
    "لا يوجد نص جاهز متاح لك في هذا النطاق بعد.",
    "اقتراحات أسئلة وموضوعات من نصوص جاهزة، وليست إجابات ذكاء اصطناعي موثقة. تعرض موضوعات الكتب صفحات PDF المطابقة."
  ],
  "ru": [
    "Выберите вопрос или тему из готовых текстов бесед и книг. Список обновляется при публикации новых текстов.",
    "В этом разделе пока нет доступного вам готового текста.",
    "Это вопросы и темы из готовых текстов, а не проверенные ответы ИИ. Для книг указаны соответствующие страницы PDF."
  ],
  "zh": [
    "从已整理的讲座和书籍文本中选择问题或主题。新文本发布后列表会更新。",
    "此范围内尚无您可以访问的已整理文本。",
    "这些是已整理文本中的问题和主题建议，并非经验证的 AI 回答。书籍主题列出匹配的 PDF 页码。"
  ]
};

localizedCopy.fa=persianCopy(localizedCopy.tr);
export default localizedCopy;
